import { render, staticRenderFns } from "./PatientIndex.vue?vue&type=template&id=658b582f&scoped=true&"
import script from "./PatientIndex.vue?vue&type=script&lang=js&"
export * from "./PatientIndex.vue?vue&type=script&lang=js&"
import style0 from "./PatientIndex.vue?vue&type=style&index=0&id=658b582f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658b582f",
  null
  
)

export default component.exports